/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_WeightInputs */

const en_mobile_player_weight = /** @type {(inputs: Mobile_Player_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight`)
};

const es_mobile_player_weight = /** @type {(inputs: Mobile_Player_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

/**
* | output |
* | --- |
* | "Weight" |
*
* @param {Mobile_Player_WeightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_weight = /** @type {((inputs?: Mobile_Player_WeightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_WeightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_weight(inputs)
	return en_mobile_player_weight(inputs)
});